import { TOrganizationChannel } from '@/features/channel-integration/_shared/api/get-organization-channel.api';
import { TAgent } from '@/features/settings/manage-agent-team/agent/types/agent.type';
import { DateRange } from 'react-day-picker';
import { create } from 'zustand';
import { useShallow } from 'zustand/react/shallow';
import { addHours } from 'date-fns';

interface IAnalyticStore {
  timeframes: DateRange;
  agents: TAgent[];
  channels: TOrganizationChannel[];

  actions: {
    setChannels: (channels: TOrganizationChannel[]) => void;
    setAgents: (agents: TAgent[]) => void;
    setTimeframes: (timeframes: DateRange) => void;
    setClearFilter: () => void;
  };
}

//default timeframe
export const DEFAULT_START_DATE = (() => {
  return new Date();
})();

export const DEFAULT_END_DATE = (() => {
  return addHours(new Date(), 1);
})();

export const analyticStore = create<IAnalyticStore>()((set) => ({
  timeframes: { from: DEFAULT_START_DATE, to: DEFAULT_END_DATE },
  agents: [],
  channels: [],

  actions: {
    setTimeframes: (timeframes: DateRange) => set({ timeframes }),
    setAgents: (agents: TAgent[]) => set({ agents }),
    setChannels: (channels: TOrganizationChannel[]) => set({ channels }),
    setClearFilter: () =>
      set({ agents: [], channels: [], timeframes: { from: DEFAULT_START_DATE, to: DEFAULT_END_DATE } }),
  },
}));

/**
 * Selectors
 */
export const useTimeframesFilter = () => analyticStore(useShallow((state) => state.timeframes));
export const useAgentsFilter = () => analyticStore(useShallow((state) => state.agents));
export const useChannelsFilter = () => analyticStore(useShallow((state) => state.channels));

/**
 * Store
 */
export const useAnalyticStore = () => analyticStore(useShallow((state) => state.actions));
